// exports

export const MERIDIAN_OPTIONS = {
	AM: 'AM',
	PM: 'PM'
};
